import { render, staticRenderFns } from "./NewHome.vue?vue&type=template&id=1e9f0b93&scoped=true&"
import script from "./NewHome.vue?vue&type=script&lang=js&"
export * from "./NewHome.vue?vue&type=script&lang=js&"
import style0 from "./NewHome.vue?vue&type=style&index=0&id=1e9f0b93&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9f0b93",
  null
  
)

export default component.exports